const FormMode = {
  View: "view",
  Edit: "edit",
  Add: "add",
  Cancel: "cancel"
};

export default FormMode;
